"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TRUE_AS_STRING = exports.TOKEN_NAME_CSC = exports.TOKEN_NAME_CIAM = exports.GERMAN_COMPANY_SALUTATION = exports.COMPANY_SALUTATION = void 0;
var TOKEN_NAME_CIAM = exports.TOKEN_NAME_CIAM = 'ciam';
var TOKEN_NAME_CSC = exports.TOKEN_NAME_CSC = 'csc';
var COMPANY_SALUTATION = exports.COMPANY_SALUTATION = 'COMPANY';
var GERMAN_COMPANY_SALUTATION = exports.GERMAN_COMPANY_SALUTATION = 'firma';
var TRUE_AS_STRING = exports.TRUE_AS_STRING = 'true';